import { render, staticRenderFns } from "./CommonButtons.vue?vue&type=template&id=05873000"
import script from "./CommonButtons.vue?vue&type=script&lang=js"
export * from "./CommonButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports